export function debounced (fnToCall, timeout = 500) {
  let timeoutRef = null;
  return (...args) => {
    if (timeoutRef) return;
    timeoutRef = setTimeout(() => {
      fnToCall(...args);

      clearTimeout(timeoutRef);
      timeoutRef = null;
    }, timeout);
  };
};
